var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCategoryBig = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31598_96198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.86315 11.4914H17.7947C18.8684 11.4914 19.5395 10.2836 18.8684 9.47829L13.9026 1.29145C13.3658 0.486184 12.1579 0.486184 11.621 1.29145L6.65525 9.47829C6.11841 10.4178 6.78946 11.4914 7.86315 11.4914Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2104 26.2547C23.5459 26.2547 26.2498 23.5508 26.2498 20.2153C26.2498 16.8797 23.5459 14.1758 20.2104 14.1758C16.8749 14.1758 14.1709 16.8797 14.1709 20.2153C14.1709 23.5508 16.8749 26.2547 20.2104 26.2547Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1447 14.8477H2.0921C1.42105 14.8477 0.75 15.5187 0.75 16.1898V24.2424C0.75 24.9134 1.42105 25.5845 2.0921 25.5845H10.1447C10.8158 25.5845 11.4868 24.9134 11.4868 24.2424V16.1898C11.4868 15.5187 10.8158 14.8477 10.1447 14.8477Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31598_96198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCategoryBig);
export default ForwardRef;